import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';
import PosSessionContext from '../utils/PosSessionContext';
import { RiDeleteBin6Fill } from "react-icons/ri";
import EventEmitter from '../../utils/eventEmitter';
import GoBack from '../../globalComponents/GoBack';


const columns = [
  {
    title: 'Date',
    dataIndex: 'createdAt',
    key: 'createdAt',
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{new Date(record.createdAt).toUTCString()}</span>

  },
  {
    title: 'Receipt No',
    dataIndex: 'receipt_number',
    key: 'receipt_number',
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Customer',
    dataIndex: 'cus_name',
    key: 'cus_name',
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Order Total',
    dataIndex: 'total',
    key: 'total',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>GHc {record.totalAmount ? (record.totalAmount * 1).toFixed(2): 0.00}</span>
  },
  {
    title: 'Total Paid',
    dataIndex: 'totalPaid',
    key: 'totalPaid',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>GHc {record.totalAmount ? (record.totalAmount * 1).toFixed(2): 0.00}</span>
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, record) => <div>
      <Button 
        type='text'
        className='text-red-700' 
        icon={<RiDeleteBin6Fill />} 
        onClick={(e)=> {
          e.preventDefault(); 
          e.stopPropagation();
          EventEmitter.dispatch('delete_order', record);
        }}
        >Delete
      </Button>
    </div>
  }
]



const PosSessionOrders = () => {
  // const sesionOrders = useLoaderData();
  const { state, dispatch, removeOrder } = useContext(PosSessionContext);
  const navigate = useNavigate();



  useEffect(() => {
    EventEmitter.subscribe('delete_order', data => {
      if (state.orders.length > 1)  {
        const orders = removeOrder(state.orders, data.createdAt);
        console.log(orders);
        dispatch({event: 'REMOVE_ORDER', orders: orders});
      }
    });
    return () => EventEmitter.unsubscribe('delete_order');
  },[])

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => {
        let orders = [...state.orders];
        const selectedOrderIndex = orders.findIndex(order => order.is_selected === true);
        if (selectedOrderIndex > -1) {
          orders[selectedOrderIndex].is_selected = false;
          orders[rowIndex].is_selected = true;
          // console.log(orders);
          dispatch({event: 'SELECT_ORDER', orders: orders});

        }
      }
    };
  }

  
  
  return (
    <div>
      <GoBack />
      <div className='flex justify-between mx-4'>
      </div>
      <Table
        sticky
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={state.orders}
        columns={columns}
        // scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'receipt_number'}
      />
    
    </div>
  )
}

export default PosSessionOrders;